import { StoreFormattedDate } from "arkh/common";
import { Box, AHText, AHIcon } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoSubject } from "widgets/src/WidgetTodoOverview/TodoSubject/TodoSubject";

import { TodoEditNewMainCreationInfo$key } from "./__generated__/TodoEditNewMainCreationInfo.graphql";

export function TodoEditNewMainCreationInfo(props: {
  todo: TodoEditNewMainCreationInfo$key;
  showLockIcon?: boolean;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainCreationInfo on Todo {
        createdAtDate {
          ...StoreFormattedDate
        }
        subject {
          ...TodoSubject_TodoSubject
        }
      }
    `,
    props.todo
  );

  return (
    <Box
      style={{ flexDirection: "column", flex: 1 }}
      spaceHorizontal="medium"
      spaceTop="medium"
    >
      <Box style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
        {todo.subject ? <TodoSubject subject={todo.subject} /> : null}

        {props.showLockIcon ? (
          <AHIcon type="locked" size="xsmall" color="text-washed" />
        ) : null}
      </Box>
    </Box>
  );
}
